import { Card, Box, Typography, Button } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import BatteryAlertIcon from "@mui/icons-material/BatteryAlert";

const config = {
    geo: {
        color: "#2f6fed",
        bg: "#f4f8ff",
        icon: <LocationOnIcon />,
    },
    power: {
        color: "#f57c00",
        bg: "#fff6ef",
        icon: <PowerSettingsNewIcon />,
    },
    battery: {
        color: "#2e7d32",
        bg: "#f1f8f4",
        icon: <BatteryAlertIcon />,
    },
};

const AlertCard = ({ type, title, vehicle, time, status, buttonText, onClick, alertStatus }) => {
    const data = config[type] || config.geo;

    return (
        <Card
            sx={{
                borderRadius: "16px",
                p: 2.5,
                background: data.bg,
                position: "relative",
                boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                overflow: "hidden",
                height: "180px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: "5px",
                    background: data.color,
                }}
            />

            {/* FIX: Set width to 100% and restructure flexboxes to prevent text cutting off */}
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ width: "100%" }}>
                <Box display="flex" alignItems="center" gap={1.5} sx={{ flex: 1, minWidth: 0, pr: 1 }}>
                    <Box
                        sx={{
                            minWidth: 36, // Force icon box to keep shape
                            height: 36,
                            borderRadius: "10px",
                            background: `${data.color}20`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: data.color,
                        }}
                    >
                        {data.icon}
                    </Box>

                    {/* FIX: Native HTML title added for hovering, flex applied to prevent truncation cutoff */}
                    <Typography
                        fontWeight={700}
                        fontSize="16px"
                        title={title}
                        sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "block",
                        }}
                    >
                        {title}
                    </Typography>
                </Box>

                {/* {status && (
                    <Box
                        sx={{
                            fontSize: "12px",
                            px: 1.2,
                            py: 0.4,
                            borderRadius: "999px",
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                            background:
                                status === "High"
                                    ? "#ffe3c2"
                                    : status === "Resolved"
                                        ? "#c8e6c9"
                                        : status === "SENT" // Added SENT support
                                            ? "#d1e7dd" // A soft green tint for sent
                                            : "#dbeafe",
                            color: "#333",
                        }}
                    >
                        {status}
                    </Box>
                )} */}
                {alertStatus && (
                    <Box
                        sx={{
                            fontSize: "12px",
                            px: 1.2,
                            py: 0.4,
                            borderRadius: "999px",
                            fontWeight: 600,
                            background:
                                alertStatus === "Pending"
                                    ? "#fff3cd"
                                    : alertStatus === "Approved"
                                        ? "#c8e6c9"
                                        : "#f8d7da",
                        }}
                    >
                        {alertStatus}
                    </Box>
                )}
            </Box>

            {/* VEHICLE TEXT */}
            <Typography mt={1.5} fontSize="14px" color="text.secondary">
                {vehicle}
            </Typography>

            {/* TIME */}
            <Typography mt={0.5} fontSize="12px" color="text.secondary">
                {time}
            </Typography>

            {/* BUTTON */}
            <Box display="flex" justifyContent="flex-end" mt="auto">
                <Button
                    size="small"
                    onClick={onClick}
                    sx={{
                        background: data.color,
                        color: "#fff",
                        borderRadius: "8px",
                        textTransform: "none",
                        px: 2,
                        boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                        "&:hover": {
                            background: data.color,
                        },
                    }}
                >
                    {buttonText}
                </Button>
            </Box>
        </Card>
    );
};

export default AlertCard;